var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":this.to},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'arrow-left'],"size":"lg"}}),_vm._v(" "),_c('span',[_vm._v("Atrás")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }